const c = {
  name: "Target",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,2V0h2v2c9.1,0.5,16.5,7.8,17,17h2v2h-2c-0.5,9.1-7.8,16.5-17,17v2h-2v-2C9.9,37.5,2.5,30.1,2,21H0v-2h2
			C2.5,9.9,9.9,2.5,19,2z M19,4C11,4.5,4.5,11,4,19h3c0.5-6.4,5.6-11.5,12-12V4z M12.1,21H9c0.5,5.3,4.7,9.5,10,10v-3
			C15.4,27.5,12.5,24.6,12.1,21z M12.1,19c0.5-3.6,3.3-6.5,6.9-6.9V9c-5.3,0.5-9.5,4.7-10,10H12.1z M14.1,21
			c0.4,2.5,2.4,4.5,4.9,4.9V23h2v2.9c2.5-0.4,4.5-2.4,4.9-4.9H23v-2h2.9c-0.4-2.5-2.4-4.5-4.9-4.9V17h-2v-2.9
			c-2.5,0.4-4.5,2.4-4.9,4.9H17v2H14.1z M21,27.9v3c5.3-0.5,9.5-4.7,10-10h-3C27.5,24.6,24.6,27.5,21,27.9z M27.9,19h3
			c-0.5-5.3-4.7-9.5-10-10v3C24.6,12.5,27.5,15.4,27.9,19z M4,21c0.5,8,6.9,14.5,15,15v-3c-6.4-0.5-11.5-5.6-12-12H4z M21,36
			c8-0.5,14.5-6.9,15-15h-3c-0.5,6.4-5.6,11.5-12,12V36z M36,19C35.5,11,29,4.5,21,4v3c6.4,0.5,11.5,5.6,12,12H36z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Target
};
